import { useQuery } from "@tanstack/react-query";
import { retryNon4xx } from "shared/api/query-retry";
import { holdersAdminApi } from "../../api/holdersAdminApi";
export var useCollectionHolders = function (collectionId) {
    return useQuery({
        queryKey: ["admin", "holders", collectionId],
        queryFn: function () { return holdersAdminApi.getByCollection(collectionId); },
        enabled: !!collectionId,
        staleTime: 30000,
        retry: retryNon4xx,
    });
};
